import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    ($setup.store.step < $setup.store.config.steps)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          onClick: $setup.handleProceed
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($props.text || 'Proceed'), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ]))
}